var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 535.538 474.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{isolation:isolate;}.cls-4{opacity:0.19;}.cls-13,.cls-17,.cls-4{mix-blend-mode:multiply;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-33,.cls-9{fill:#00c7e5;}.cls-9{opacity:0.3;}.cls-10,.cls-22,.cls-43,.cls-45{fill:none;}.cls-10,.cls-43{stroke-miterlimit:10;}.cls-10{stroke-width:19.44px;stroke:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:#9ce3ee;}.cls-13{fill:#ebecf0;opacity:0.62;}.cls-14{fill:#0065ff;}.cls-15{fill:url(#linear-gradient-9);}.cls-16{fill:#1db9d4;}.cls-17{fill:url(#linear-gradient-10);}.cls-18{fill:#3384ff;}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:#ff5230;}.cls-21{fill:#fff;}.cls-22{stroke:#ff5230;stroke-width:2.321px;}.cls-23{fill:#e0ada6;}.cls-24{fill:#253858;}.cls-25{fill:url(#linear-gradient-12);}.cls-26{fill:url(#linear-gradient-13);}.cls-27{fill:url(#linear-gradient-14);}.cls-28{clip-path:url(#clip-path-2);}.cls-29{fill:#091e42;}.cls-30{fill:url(#New_Gradient_Swatch_13);}.cls-31{fill:url(#New_Gradient_Swatch_13-2);}.cls-32{fill:url(#New_Gradient_Swatch_13-3);}.cls-34{fill:url(#linear-gradient-16);}.cls-35{fill:#9c7761;}.cls-36{fill:#344563;}.cls-37{fill:#b5917c;}.cls-38{fill:url(#radial-gradient);}.cls-39{fill:url(#radial-gradient-2);}.cls-40{fill:url(#New_Gradient_Swatch_11);}.cls-41{fill:url(#New_Gradient_Swatch_2);}.cls-42{fill:url(#New_Gradient_Swatch_2-2);}.cls-43{stroke:#ff5630;stroke-width:2px;}.cls-44{fill:#505f79;}.cls-46{fill:url(#linear-gradient-17);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -136.716,
    y1: 85.338,
    x2: 4.399,
    y2: 85.338,
    gradientTransform: "matrix(0.818, -0.355, 0, 1, 88.514, 172.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#bbd6ff",
    stopOpacity: 0.332
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#5a9cff",
    stopOpacity: 0.809
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3384ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 292.375,
    y1: 66.313,
    x2: 311.681,
    y2: 66.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#0060f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    stopColor: "#0052cc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_Clipping_Path_",
    "data-name": "<Clipping Path>",
    className: "cls-1",
    points: "103.743 321.455 0 366.224 0 225.881 103.743 192.373 103.743 321.455"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -158.115,
    y1: 294.262,
    x2: 51.105,
    y2: 294.262,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -158.115,
    y1: 309.083,
    x2: 51.105,
    y2: 309.083,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -158.115,
    y1: 301.206,
    x2: 51.105,
    y2: 301.206,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 376.152,
    y1: 474.071,
    x2: 376.152,
    y2: 246.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0065ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#0065ff",
    stopOpacity: 0.673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0065ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 381.752,
    y1: 248.741,
    x2: 319.155,
    y2: 35.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bd5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#67d4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#5cd0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#49c9de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#2fbfd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#1db9d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 297.786,
    y1: 271.526,
    x2: 297.786,
    y2: 100.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a3bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#00c7e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 242.54,
    y1: 73.753,
    x2: 473.423,
    y2: 304.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#7a869a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a869a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 22.116,
    y1: 169.947,
    x2: 173.833,
    y2: 18.23,
    gradientTransform: "matrix(0.818, -0.355, 0, 1, 88.514, 172.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#3384ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 287.083,
    y1: 124.032,
    x2: 287.083,
    y2: 77.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#2684ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#2481fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#1c77f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1067e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0052cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 298.353,
    y1: 125.998,
    x2: 298.353,
    y2: 77.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#2684ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#227ffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#1771eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#0559d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0052cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 274.475,
    y1: 59.599,
    x2: 295.653,
    y2: 59.599,
    gradientTransform: "translate(96.557 -164.022) rotate(37.942)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#005ae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#0052cc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Clipping_Path_2",
    "data-name": "<Clipping Path>",
    className: "cls-2",
    d: "M309.714,54.989c2.04,1.878,2.36,5.189,1.57,8.535-.382,1.62-.347,2.447-.557,3.721a28.089,28.089,0,0,0,.471,10.876c-.47.12-1.175.287-2.04.446a42.432,42.432,0,0,1-5.06.528c-2.593.185-3.9.282-4.588.244a21.493,21.493,0,0,1-3.845-.563c.732-5.805-.342-9.334-1.546-11.525-.741-1.349-2.216-3.436-1.6-5.588.234-.812.749-1.575,1.206-3.334a16.269,16.269,0,0,0,.423-2.3l1.942-1.586a4.353,4.353,0,0,0,7.127-1.082,8.549,8.549,0,0,1,1.19-.086C304.852,53.278,307.885,53.306,309.714,54.989Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_13",
    x1: -40.95,
    y1: -1059.962,
    x2: -36.771,
    y2: -1064.142,
    gradientTransform: "matrix(1, 0, 0, -1.522, 312.893, -1573.203)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3f5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_13-2",
    x1: -40.594,
    y1: -1065.291,
    x2: -37.128,
    y2: -1068.757,
    gradientTransform: "matrix(1, 0, 0, -1.522, 320.464, -1580.944)",
    xlinkHref: "#New_Gradient_Swatch_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_13-3",
    x1: -40.185,
    y1: -1070.019,
    x2: -37.537,
    y2: -1072.667,
    gradientTransform: "matrix(1, 0, 0, -1.522, 326.899, -1587.525)",
    xlinkHref: "#New_Gradient_Swatch_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 295.563,
    y1: 77.114,
    x2: 319.051,
    y2: 62.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#2684ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#086cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#005ae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#0052cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 333.607,
    cy: 227.537,
    r: 18.393,
    gradientTransform: "translate(472.978 -130.301) rotate(81.59) scale(1 0.836)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#00b8d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#00b5d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#00adcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#00a3bf"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 336.354,
    cy: 227.33,
    r: 22.804,
    gradientTransform: "matrix(0.032, 0.999, -0.663, 0.021, 476.454, -113.664)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#00c4e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#00b9da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#00b8d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11",
    x1: 310.986,
    y1: 194.755,
    x2: 363.199,
    y2: 194.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a3bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    x1: 330.492,
    y1: 219.33,
    x2: 330.492,
    y2: 191.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8f73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-2",
    x1: 343.475,
    y1: 219.534,
    x2: 343.475,
    y2: 191.768,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 116.917,
    y1: -2418.323,
    x2: 110.364,
    y2: -2429.673,
    gradientTransform: "matrix(0.912, -0.365, -0.022, -1.088, -45.115, -2378.143)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Incoming") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_Clipping_Path_3",
    "data-name": "<Clipping Path>",
    className: "cls-1",
    points: "103.743 321.455 0 366.224 0 225.881 103.743 192.373 103.743 321.455"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 5.398,
    y1: 302.743,
    x2: 44.515,
    y2: 285.781
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 5.398,
    y1: 317.564,
    x2: 44.515,
    y2: 300.602
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 5.398,
    y1: 309.687,
    x2: 44.515,
    y2: 292.725
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M151.657,108.409c8.351.127,7.9,4.325,14.51,3.148,7.577-1.348,8.567-11.762,19.038-11.762,17.342,0,17.333,18.018,17.333,18.018s2.945,8.756,9.98,9.083a1.288,1.288,0,0,1,.287.025c0,.219-68.3.082-91.323.036-6.854-.014-20.048-.044-26.595-.062,10.939-4.014,16.046-4.736,18.487-4.09,5.563,1.472,2.827-6.3,12.407-8.45,7.553-1.694,8.888,1.251,12.952,1.251C145.931,115.607,141.514,109.391,151.657,108.409Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M474.391,8.614c8.351.127,7.9,4.325,14.51,3.148C496.477,10.413,497.468,0,507.938,0c17.342,0,17.333,18.018,17.333,18.018s2.945,8.756,9.98,9.083a1.288,1.288,0,0,1,.287.025c0,.219-68.3.082-91.323.036-6.854-.014-20.048-.044-26.595-.062,10.939-4.014,16.046-4.736,18.487-4.09,5.563,1.472,2.827-6.3,12.407-8.45,7.553-1.694,8.888,1.251,12.952,1.251C468.665,15.812,464.247,9.6,474.391,8.614Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 376.152,
    y1: 246.333,
    x2: 376.152,
    y2: 474.071
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M508.348,292.622c-1.236-12.277-4.055-16.728-14.045-16.8s-10.56,3.127-13.713,5.658-5.688,1.941-9.706,1.224-8.655-1.181-12.673,1.434-4.637,3.8-10.077,3.333c-4.73-.4-5.955-.353-8.172.27a16.478,16.478,0,0,0-3.05,1.34c-5.09,2.58-6.065,4.342-9.4,5.643a17.024,17.024,0,0,1-6.146,1.1l86.984.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-11",
    d: "M427.644,49.459a58.919,58.919,0,0,0-18.08,2.828c-.288.088-128.712,40.5-129,40.6a58.992,58.992,0,0,0-41.748,56.411V271.619H356.755l129.858-44.872V104.422C486.613,71.855,460.211,49.459,427.644,49.459Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "486.613 211.789 486.607 211.772 357.229 255.418 358.006 257.721 486.613 214.335 486.613 211.789"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "486.607 203.459 357.229 247.104 358.006 249.407 486.613 206.022 486.613 203.476 486.607 203.459"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "486.607 118.245 357.229 161.892 358.006 164.194 486.613 120.808 486.613 118.262 486.607 118.245"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "486.607 109.932 357.229 153.578 358.006 155.881 486.613 112.495 486.613 109.948 486.607 109.932"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M373.347,256.707V130.557a58.977,58.977,0,0,0-37.716-55.005l-5.756,1.812A58.988,58.988,0,0,1,368.8,132.832v122.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    className: "cls-14",
    d: "M297.786,90.325a58.969,58.969,0,0,0-58.969,58.969V271.619H356.755V149.294A58.969,58.969,0,0,0,297.786,90.325Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M356.755,224.881h0l-16.42,6.494C317.452,217.521,302,192.09,301.964,166.281a75.843,75.843,0,0,0-37.723-65.476,58.891,58.891,0,0,0-25.423,48.446V271.526l93.075-36.811Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M297.786,90.325c-1.346,0-2.676.061-4,.15h8C300.462,90.387,299.132,90.325,297.786,90.325Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M301.964,166.281c.038,25.809,15.488,51.24,38.371,65.094l16.42-6.494V149.294a58.961,58.961,0,0,0-54.969-58.819h-8a58.628,58.628,0,0,0-29.546,10.33A75.843,75.843,0,0,1,301.964,166.281Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M301.964,166.281c.038,25.809,15.488,51.24,38.371,65.094l16.42-6.494V149.294a58.961,58.961,0,0,0-54.969-58.819h-8a58.628,58.628,0,0,0-29.546,10.33A75.843,75.843,0,0,1,301.964,166.281Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Clipping_Path_4",
    "data-name": "<Clipping Path>",
    className: "cls-18",
    d: "M297.917,433.7c-32.568,0-58.969-23.636-58.969-52.792V271.393H356.885V380.905C356.885,410.062,330.484,433.7,297.917,433.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_3",
    "data-name": "<Path>",
    className: "cls-19",
    points: "248.699 258.602 94.887 325.299 94.887 194.551 248.699 143.216 248.699 258.602"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "378.124 72.088 373.347 73.941 373.347 256.698 378.124 254.845 378.124 98.244 407.334 87.546 407.334 62.231 378.124 72.088"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "241.831 179.947 220.456 189.216 220.456 162.149 241.831 153.813 241.831 179.947"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M184.7,192.47c3.309-1.435,3.309,1.722,6.617.288s3.31-4.592,6.619-6.027,3.309,1.722,6.617.288,3.311-4.593,6.622-6.028a3.993,3.993,0,0,1,1.624-.384"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M184.7,204.221c3.309-1.435,3.309,1.722,6.617.288s3.31-4.592,6.619-6.027,3.309,1.722,6.617.288,3.311-4.593,6.622-6.028a3.677,3.677,0,0,1,1.9-.367"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M184.7,198.346c3.309-1.435,3.309,1.722,6.617.288s3.31-4.592,6.619-6.027,3.309,1.722,6.617.288,3.311-4.593,6.622-6.028a5.342,5.342,0,0,1,.731-.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    className: "cls-22",
    d: "M233.332,177.632c0,7.232-4.8,15.175-10.711,17.74s-10.711-1.218-10.711-8.451,4.8-15.175,10.711-17.74S233.332,170.4,233.332,177.632Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M294.376,79.076c-12.172,4.071-18.2,6.466-20.009,10.37-.934,2.015-.583,2.9-.54,9.438a145.2,145.2,0,0,1-.868,16.945,8.264,8.264,0,0,1-.512,1.669c-1.59,3.715-5.3,4.673-5.027,5.717.2.75,2.316,1.016,3.925.662,1.025-.226,2.276-1.3,4.777-3.452.867-.746,1.486-1.243,1.649-2.123a9.087,9.087,0,0,0-.216-2.337h0a9.486,9.486,0,0,1-.162-1.872c-.244-1.455,4.407-10.288,5.368-16.663A21.635,21.635,0,0,0,283,94.173a74.506,74.506,0,0,0,15.765-4.81,10.342,10.342,0,0,0,2.226-8.013,9.3,9.3,0,0,0-1.742-3.927C298.023,77.817,296.363,78.411,294.376,79.076Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M284.676,102.975c-.15-2.27-.348-4.542-.351-6.817,0-2.691.171-4.973.361-7.719a3.957,3.957,0,0,1,2.007-3.143l16.747-8.046,5,.235a4.429,4.429,0,0,1,2.162.986c1.229,1.065,1.552,3.11,1.667,3.892a10.032,10.032,0,0,1,.042,2.741c-.439,2.713-6.071,3.573-14.672,6.366l-3.6,1.242a42.646,42.646,0,0,1-.166,7.178,43.081,43.081,0,0,1-3.518,12.958c-1.654,2.708-1.723,4.592-1.445,5.84a3.774,3.774,0,0,1,.246,2.152c-.316,1-1.2,1.254-3.072,2.489-2.366,1.562-2.107,1.92-3.223,2.32-1.95.7-4.671.3-5.036-.775-.508-1.49,4.153-2.421,6.481-6.73C285.53,115.872,285.245,111.573,284.676,102.975Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M294.6,45.948c-.676.278.958,3.069-.149,5.954-1.095,2.853-3.733,2.834-4.242,5.507-.274,1.44.13,3.338,1.3,3.907,1.513.735,3.614-1.081,3.87-1.3,3.012-2.6,3.435-7.77,1.712-11.312C296.353,47.176,295.109,45.74,294.6,45.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M296.717,49.781a7.179,7.179,0,0,1,.278,2.366,7.255,7.255,0,0,1-.948,3.218,9.468,9.468,0,0,0,6.548-.574,9.161,9.161,0,0,1,1.247-7.191Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M300.99,81.349a9.3,9.3,0,0,0-1.742-3.927c-1.225.394-2.884.989-4.872,1.653-12.172,4.071-18.2,6.466-20.009,10.37-.934,2.015-.583,2.9-.54,9.438a145.1,145.1,0,0,1-.791,16.22,7.846,7.846,0,0,1,4.366-1.337c.269-2.135,4.453-10.326,5.359-16.338A21.635,21.635,0,0,0,283,94.173a74.506,74.506,0,0,0,15.765-4.81A10.342,10.342,0,0,0,300.99,81.349Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M312.266,82.363c-.115-.782-.438-2.828-1.667-3.892a4.429,4.429,0,0,0-2.162-.986l-5-.235L286.692,85.3a3.957,3.957,0,0,0-2.007,3.143c-.19,2.746-.365,5.029-.361,7.719,0,2.275.2,4.547.351,6.817.48,7.25.754,11.437.094,13.936a8.371,8.371,0,0,1,3.371-.667c.266,0,.52.018.772.038a10.68,10.68,0,0,1,1.438-3.433,43.081,43.081,0,0,0,3.518-12.958,42.646,42.646,0,0,0,.166-7.178l3.6-1.242c8.6-2.793,14.233-3.653,14.672-6.366A10.032,10.032,0,0,0,312.266,82.363Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M313.235,80.918"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M294.891,55.53a28.349,28.349,0,0,1-5.13,3.058,34.548,34.548,0,0,0-4.955,2.559c-.483.308-.873.576-1.136.761,0-.683-.016-1.722-.095-2.987-.132-2.1-.35-3.4-.763-6.434-.147-1.079-.356-2.66-.594-4.6l-2.557-.357a58.4,58.4,0,0,0-.907,7.629,33.021,33.021,0,0,0,.21,7.41,28.43,28.43,0,0,0,.655,3.071,1.507,1.507,0,0,0,1.548,1.116,30.456,30.456,0,0,0,4.025-.522c2.936-.582,8.66-1.718,11.341-5.974.441-.7,1.615-2.565.85-3.762A3.022,3.022,0,0,0,294.891,55.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M296.532,60.256c.441-.7,1.615-2.565.85-3.762a3.022,3.022,0,0,0-2.491-.964,28.349,28.349,0,0,1-5.13,3.058,34.548,34.548,0,0,0-4.955,2.559c-.483.308-.873.576-1.136.761,0-.683-.016-1.722-.095-2.987-.132-2.1-.35-3.4-.763-6.434-.068-.5-.15-1.114-.241-1.812a7.146,7.146,0,0,1-3.4.032c-.219,1.687-.349,3.2-.414,4.449a33.021,33.021,0,0,0,.21,7.41,28.43,28.43,0,0,0,.655,3.071,1.507,1.507,0,0,0,1.548,1.116,30.456,30.456,0,0,0,4.025-.522C288.127,65.648,293.851,64.512,296.532,60.256Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Clipping_Path_5",
    "data-name": "<Clipping Path>",
    className: "cls-2",
    d: "M309.714,54.989c2.04,1.878,2.36,5.189,1.57,8.535-.382,1.62-.347,2.447-.557,3.721a28.089,28.089,0,0,0,.471,10.876c-.47.12-1.175.287-2.04.446a42.432,42.432,0,0,1-5.06.528c-2.593.185-3.9.282-4.588.244a21.493,21.493,0,0,1-3.845-.563c.732-5.805-.342-9.334-1.546-11.525-.741-1.349-2.216-3.436-1.6-5.588.234-.812.749-1.575,1.206-3.334a16.269,16.269,0,0,0,.423-2.3l1.942-1.586a4.353,4.353,0,0,0,7.127-1.082,8.549,8.549,0,0,1,1.19-.086C304.852,53.278,307.885,53.306,309.714,54.989Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 292.038,
    y1: 65.434,
    x2: 292.152,
    y2: 61.937
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M291.951,39.007"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M294.322,39.432a4.769,4.769,0,0,0-1.3,3.069L293,43.16s.032.373-.871,1.615c-.279.384,1.2.782,1.2.782a5.74,5.74,0,0,0,.12,1.793c.06.255.1.32.217.8a9.069,9.069,0,0,0,.325,1.35c.2.327.768.627,2.47.4a10.764,10.764,0,0,1,4.46-.637,2.55,2.55,0,0,0,2.923-1.657,6.142,6.142,0,0,0,1.085-1.827,6.281,6.281,0,0,0-.518-5.645,6.913,6.913,0,0,0-.9-1.112,5.019,5.019,0,0,0-4.3-1.345l-2.123.319A4.775,4.775,0,0,0,294.322,39.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M292.259,41.751q1.318.089,2.7.219t2.7.3a15.394,15.394,0,0,0-.161,2.507,25.653,25.653,0,0,0,1.034,4.752,7.074,7.074,0,0,1-.183,4.769c-.8,1.6-1.192,1.914-1.152,3.041a3.906,3.906,0,0,0,2.839,3.482c2.047.417,4.018-1.722,4.846-2.621,1.688-1.832,2.029-3.546,3.36-3.68a2.322,2.322,0,0,1,1.623.592,8.665,8.665,0,0,0,.721-5.071,8.354,8.354,0,0,0-.988-2.728A17.917,17.917,0,0,0,307.682,45a12.717,12.717,0,0,1-1.636-3.761,6.357,6.357,0,0,0-2.2-3.4,6.505,6.505,0,0,0-2.4-.837,11.92,11.92,0,0,0-4.553-.179,5.665,5.665,0,0,0-4.635,4.925Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M282.515,46.878a3.58,3.58,0,0,1-.829.9,2.138,2.138,0,0,1-.906.3c-.713.106-.937.763-1.194.647s.063-.816-.2-1.957c-.149-.656-.325-.716-.331-1.241a3.367,3.367,0,0,1,.36-1.366c.277-.69.469-.769.575-.785a.6.6,0,0,1,.462.189c.112-.526.281-.691.429-.73.276-.074.728.223.728.223.052-.072.38-.523.631-.448.086.026.135.1.292.469.293.681.244.69.335.785.312.324.765.08.995.393a.765.765,0,0,1,.065.595c-.065.373-.266.528-.72,1.1C282.873,46.365,282.967,46.3,282.515,46.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M280.112,47.633c-.11-.3.2-.677.857-1.362a4.23,4.23,0,0,1,1.506-1.11c.726-.3.8-.039,1.521-.364.6-.267.817-.56,1.313-.529.284.018.629.141.65.312s-.24.3-.452.426a9.5,9.5,0,0,0-1.456,1.088,2.133,2.133,0,0,1-.5,1.134,2.231,2.231,0,0,1-1.091.654C281.578,48.157,280.295,48.129,280.112,47.633Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M272.4,39.873h3.271a0,0,0,0,1,0,0V47.5a.39.39,0,0,1-.39.39h-2.492a.39.39,0,0,1-.39-.39V39.873a0,0,0,0,1,0,0Z",
    transform: "translate(236.27 318.823) rotate(-91.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M280.384,40.15h2.434a0,0,0,0,1,0,0v6.729a.4.4,0,0,1-.4.4h-1.64a.4.4,0,0,1-.4-.4V40.15A0,0,0,0,1,280.384,40.15Z",
    transform: "translate(244.178 326.219) rotate(-91.278)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 287.277,
    y: 40.696,
    width: 1.52,
    height: 5.748,
    transform: "matrix(-0.022, -1, 1, -0.022, 250.9, 332.506)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 289.992,
    y: 43.2,
    width: 2.421,
    height: 0.586,
    rx: 0.237,
    ry: 0.237,
    transform: "translate(254.214 335.593) rotate(-91.278)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 267.587,
    y: 43.501,
    width: 3.922,
    height: 0.949,
    rx: 0.385,
    ry: 0.385,
    transform: "translate(231.593 314.437) rotate(-91.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M282.441,43.68a.511.511,0,0,1-.354-.086c-.264-.172-.25-.509-.359-.513-.132,0-.144.492-.427.586a.459.459,0,0,1-.4-.1c-.206-.165-.129-.4-.26-.467-.23-.119-.605.532-.906.45-.268-.073-.447-.706-.272-1.2.248-.7,1.13-.907,1.431-.979a3.717,3.717,0,0,1,2,.233c.6.166.8.308.914.5a1.365,1.365,0,0,1,.128.823c-.015.2-.034.452-.155.493-.2.066-.42-.509-.7-.467S282.8,43.608,282.441,43.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M277.555,115.964a8.1,8.1,0,0,1-.121-.83c-.023-.248-.032-.463-.036-.633-.223.328-.548.823-.911,1.442-1.244,2.12-1.339,2.969-2.118,3.4-.5.276-1.337.419-2.832-.262-.6.483-1.456,1.2-2.457,2.128-1.6,1.482-1.72,1.778-1.66,2,.19.716,2.212,1.039,3.925.662,1.025-.226,2.276-1.3,4.777-3.452,1.074-.923,1.554-1.4,1.649-2.123A9.413,9.413,0,0,0,277.555,115.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M288.791,117.2a6.228,6.228,0,0,0-1.162.927c-1.453,1.478-1.133,2.67-2.387,3.627a3.564,3.564,0,0,1-2.465.693,3.36,3.36,0,0,1-1.656-.7c-1.9,1.469-3.619,2.186-3.3,3.121.366,1.074,3.086,1.474,5.036.775.76-.272.883-.525,1.631-1.152a13.559,13.559,0,0,1,1.592-1.167c.914-.588,1.36-.72,1.865-1.074a4.044,4.044,0,0,0,.492-.4,3.451,3.451,0,0,0,.834-1.011c.225-.513,0-.872-.256-2.152C288.89,118.056,288.826,117.535,288.791,117.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M308.174,54.517a2.986,2.986,0,0,1,2.27,1.081c.757.81,1.031,1.843,1.132,3.558a21.578,21.578,0,0,1-.393,5.566c-.4,1.93-.964,4.7-1.7,8.559a47.38,47.38,0,0,1-6.229,15.759l-2.512-.842c.383-1.091.653-1.973.809-2.5,1.577-5.334,1.393-7.84,3.206-11.717.363-.776.7-1.375.878-1.688q-.089-1.532-.148-3.1c-.151-4.062-.128-7.965.029-11.694A3.4,3.4,0,0,1,308.174,54.517Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M299.05,89.428a7.251,7.251,0,0,0-1.69.948,8.338,8.338,0,0,0,.352,3.753.533.533,0,0,0,.276.162.438.438,0,0,1,.769.2.686.686,0,0,0,.806-.306.651.651,0,0,0,.5.658.635.635,0,0,0,.61-.247l.171-3.151a1.783,1.783,0,0,1,.53-.3c.413-.147.645-.047,1.084-.2a1.66,1.66,0,0,0,.482-.253c.8-.646.544-2.44.544-2.44h0l-2.6-.379a3.486,3.486,0,0,1-.755,1.231A7.2,7.2,0,0,0,299.05,89.428Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M311.576,59.157c-.1-1.716-.374-2.748-1.132-3.558a2.986,2.986,0,0,0-2.27-1.081,3.4,3.4,0,0,0-2.655,2.979c-.157,3.728-.18,7.632-.029,11.694q.058,1.57.148,3.1c-.18.313-.515.912-.878,1.688-1.8,3.839-1.635,6.338-3.163,11.564a7.265,7.265,0,0,1,2.859,1.449,47.251,47.251,0,0,0,5.029-13.711c.733-3.861,1.295-6.63,1.7-8.559A21.578,21.578,0,0,0,311.576,59.157Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M333.718,191.873a3.834,3.834,0,0,0,6.334-.1,4.47,4.47,0,0,1-.469-1.168,5.684,5.684,0,0,1-.107-1.561,11.506,11.506,0,0,1,.256-2.04L334,188.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M339.54,187.134l1.371-.959a2.9,2.9,0,0,0,1.176-1.755l.121-.553a17.7,17.7,0,0,0,.405-4.114,2.4,2.4,0,0,0-1.314-2.081l-.215-.11a13.483,13.483,0,0,0-5.015-1.438l-3.42-.291a1.692,1.692,0,0,0-1.689-.668c-.778.24-.926,1.316-.736,2a2.23,2.23,0,0,0,1.08,1.279l2.891,5.979Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M331.946,178.316a19.268,19.268,0,0,0-1.106,4.642,7.76,7.76,0,0,1-.393.674c-.576.883-1.171,1.407-1.009,1.624.014.019.693.28.809.372.243.193.1,2.253.573,3.094.951,1.707,6.531,2.087,8.322-.46a3.492,3.492,0,0,0,.59-2.073,2.378,2.378,0,0,1-.3-.113,2.509,2.509,0,0,1-1.187-1.136c-.453-.961.281-1.735-.191-2.117a.812.812,0,0,0-.754-.089c-.69.27-.79,1.7-.79,1.7h-.022c-.012,0-.269-.058-1.041-.242-.011-2.5-.663-3.433-1.3-3.8a5.411,5.411,0,0,1-1.259-.824A4.432,4.432,0,0,1,331.946,178.316Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M329.07,215.784c.2,2.652.5,6.55.938,11.278.561,6.079.854,9.118,1.054,10.139,1.068,5.443,3.8,14.295,4.627,19.139a6.489,6.489,0,0,1-.049,2.661,7.59,7.59,0,0,1-2.434,3.818c-1.275,1.057-2.5,1.284-2.431,1.7.067.4,1.248.673,2.307.49,1.192-.207,1.256-.828,3.018-1.794a13.534,13.534,0,0,0,2.535-1.394,2.048,2.048,0,0,0,.224-.33,4.092,4.092,0,0,0,.114-3.182l-3.011-43.223Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M335.257,215.317c1.026,13.008,1.433,18.1,1.459,18.314l0,.021c.271,2.312.56,2.64.592,3.636.028.864-.19.6-.378,2.58-.074.781-.091,1.4-.1,1.754-.012.4-.01.879.02,1.57.2,4.669.978,5.03,1.568,10.766a65.067,65.067,0,0,1,.42,8.672c-.021.926-.071,2.164-.194,3.628a3.236,3.236,0,0,1,.787,1.068c.419.935.11,1.578.6,2.031a1.9,1.9,0,0,0,1.342.346c.727.019,2.108-.151,2.316-.822.155-.5-.437-.954-.886-1.607-.863-1.252-.821-2.682-.658-4.721.42-5.239,1.431-11.831,1.715-14.466.194-1.806.347-3.664.347-3.664.041-.489.082-1.017.129-1.7.346-4.964.405-9.217.524-17.724.052-3.737.067-6.821.071-8.909a1.083,1.083,0,0,0-.089-.727c-.451-.8-2.123-.6-4.2-.418C339.415,215.053,337.576,215.2,335.257,215.317Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M338.967,258.206a8.031,8.031,0,0,1-2.8.528c-.154,0-.3-.015-.455-.023-.024.1-.039.193-.069.291,0,0-.062.231-.151.467a6.588,6.588,0,0,1-2.046,2.941,3.243,3.243,0,0,0-2.538,1.536,2.2,2.2,0,0,0-.193.813,4.151,4.151,0,0,0,2.371.253,4.29,4.29,0,0,0,.63-.185,7.609,7.609,0,0,0,2.425-1.478,7.891,7.891,0,0,0,2.889-1.265q0-.453-.01-.908Q339,259.682,338.967,258.206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M342.141,262.552c.017-.208.036-.421.054-.633a17.023,17.023,0,0,1-3.352.274c0,.147,0,.286,0,.436-.021.926-.071,2.164-.194,3.628a3.236,3.236,0,0,1,.787,1.068c.419.935.11,1.578.6,2.031a1.9,1.9,0,0,0,1.342.346c.727.019,2.108-.151,2.316-.822.155-.5-.437-.954-.886-1.607C341.936,266.022,341.977,264.591,342.141,262.552Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M360.073,172.63a40.724,40.724,0,0,1-1.923,4.724c-1.283,2.656-2.315,4.035-3.09,6.734a19.522,19.522,0,0,0-.559,2.6,42.566,42.566,0,0,0-5.741,4.041q-.238.2-.468.4a4.361,4.361,0,0,1-1.76.921,4.479,4.479,0,0,1-1.313.131c-1.961-.062-4.655-.357-5.167-.414a4.278,4.278,0,0,1-3.468,1.6,4.149,4.149,0,0,1-2.866-1.5c-.652.062-2.82.264-4.72.323a4.516,4.516,0,0,1-1.368-.141,4.357,4.357,0,0,1-1.719-.91q-.24-.207-.487-.413a42.559,42.559,0,0,0-5.741-4.041,19.546,19.546,0,0,0-.559-2.6c-.775-2.7-1.807-4.078-3.09-6.734a40.768,40.768,0,0,1-1.923-4.724l-3.126.817a65.794,65.794,0,0,0,2.847,12.148c.535,1.585,1.108,3.081,1.7,4.487a26.549,26.549,0,0,0,4.452,5.052,38.819,38.819,0,0,1,4.927,4.369,20.523,20.523,0,0,1,2.226,3.123c.014.182.028.365.046.548a55.569,55.569,0,0,0,2.754,12.653,28.651,28.651,0,0,0,16.961-.489c-.1-4.405-.093-9.01.056-13.8,1.429-1.615,2.664-2.839,3.48-3.619,4.619-4.411,7.285-5.523,8.969-9.247a21.013,21.013,0,0,0,.948-3.08c.821-3.019,1.848-7.121,2.847-12.148Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M333.91,203.121q-.024-5.737-.192-11.248l-4.32.229a14.847,14.847,0,0,1-2.256,10.629q-.036,7.464-.071,14.929a24.162,24.162,0,0,0,6.606,1.67Q333.936,211.464,333.91,203.121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M345.14,192.084l-5.088-.316q-.028,13.883-.057,27.766a8.089,8.089,0,0,0,5.7-2.373,6.914,6.914,0,0,0,1.206-1.821q.028-6.9.056-13.8a16.043,16.043,0,0,1-1.814-9.457Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M311.945,173.192a1.731,1.731,0,0,0,1.685.105,2.571,2.571,0,0,0,1.342-2.216c.053-.913-.4-1.176-.528-2.452a5.9,5.9,0,0,1,.072-1.632,1.556,1.556,0,0,0-.829.4,1.792,1.792,0,0,0-.35,1.882,2.688,2.688,0,0,0-1.239.847C311.391,171.012,311.164,172.568,311.945,173.192Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 313.526,
    y1: 172.494,
    x2: 310.371,
    y2: 160.027
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M311.1,174.071c-.351-1.545-.633-2.733-.886-3.729a1.64,1.64,0,0,1-.047-.682,2.727,2.727,0,0,1,2.754-1.911c.109.017.4.063.475.25s-.138.368-.049.61c.071.19.236.164.281.334.066.251-.26.439-.177.637.054.129.214.1.293.238.1.175-.034.421-.085.517a1.581,1.581,0,0,1-1.053.689,1.307,1.307,0,0,1,.771.618c.321.678-.273,1.527-.761,1.925A2.38,2.38,0,0,1,311.1,174.071Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M362.227,172.866a1.731,1.731,0,0,1-1.685.105,2.571,2.571,0,0,1-1.342-2.216c-.053-.913.4-1.176.528-2.452a5.9,5.9,0,0,0-.072-1.632,1.556,1.556,0,0,1,.829.4,1.792,1.792,0,0,1,.35,1.882,2.688,2.688,0,0,1,1.239.847C362.782,170.685,363.008,172.242,362.227,172.866Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 360.646,
    y1: 172.168,
    x2: 363.802,
    y2: 159.701
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M363.074,173.745c.351-1.545.633-2.733.886-3.729a1.64,1.64,0,0,0,.047-.682,2.727,2.727,0,0,0-2.754-1.911c-.109.017-.4.063-.475.25s.138.368.049.61c-.071.19-.236.164-.281.334-.066.251.26.439.177.637-.054.129-.214.1-.293.238-.1.175.034.421.085.517a1.581,1.581,0,0,0,1.053.689,1.307,1.307,0,0,0-.771.618c-.321.678.273,1.527.761,1.925A2.38,2.38,0,0,0,363.074,173.745Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M348.795,213.749"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "193.431 225.452 158.363 238.907 158.363 244.277 193.431 230.174 193.431 225.452"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "193.431 233.407 158.363 247.51 158.363 252.387 193.431 238.056 193.431 233.407"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "193.431 223.845 158.363 237.3 158.363 238.907 193.431 225.452 193.431 223.845"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "193.431 223.845 193.431 222.239 158.363 235.694 158.363 237.3 193.431 223.845"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "193.431 239.676 193.431 238.056 158.363 252.387 158.363 254.007 193.431 239.676"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "158.363 254.007 158.363 255.628 193.431 241.297 193.431 239.676 158.363 254.007"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "193.431 231.791 158.363 245.893 158.363 247.51 193.431 233.407 193.431 231.791"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "193.431 231.791 193.431 230.174 158.363 244.277 158.363 245.893 193.431 231.791"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M112.683,209.117c-.354-.3-.9-.06-1.114.6l-5.381,15.769c-.159.466-.014.9.324.962a.542.542,0,0,0,.305-.036l7.882-3.159a1.1,1.1,0,0,0,.6-.7C116.908,217.689,115.747,211.726,112.683,209.117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M116.582,195.167c-3.043,7.254-2.7,13.8-.508,17.938l3.987,7.545a.458.458,0,0,0,.615.211l7.882-3.159a1.2,1.2,0,0,0,.66-1.078.745.745,0,0,0-.079-.333s-11.126-21.066-11.4-21.592C117.482,194.231,116.876,194.461,116.582,195.167Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingMessage);
export default __webpack_public_path__ + "static/media/incoming-message.bea13ef9ce19d3c851a9d5052d7b4a2c.svg";
export { ForwardRef as ReactComponent };